<template>
    <select
        id="settingsWallpaper"
        v-model="selectedWallpaper"
        name="settingsWallpaper"
        class="mb-2"
    >
        <option
            v-for="wallpaper in wallpapers"
            :key="wallpaper.id"
            :value="wallpaper.id"
        >
            {{ wallpaper.name }}
        </option>
    </select>
</template>

<script>
import WALLPAPERS, { getWallpaperFromStorage } from '@/constants/wallpapers';

export default {
    props: {
        value: {
            type: Object,
            default: getWallpaperFromStorage
        }
    },
    data: () => ({
        wallpapers: WALLPAPERS
    }),

    computed: {
        selectedWallpaper: {
            get() {
                return this.value && this.value.id;
            },
            set(value) {
                const wallpaper = this.wallpapers.find(
                    ({ id }) => id === value
                );
                this.$emit('input', wallpaper);
            }
        }
    }
};
</script>
